// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c4296ef","455":"52574a5c"}[chunkId] + ".chunk.js";
};